import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import SpecificProfile from "./pages/SpecificProfile";
import GuideAlgae from "./pages/GuideAlgae.jsx";
import GarbDisp from "./pages/GuideGarbDisp.jsx";
import LoggingWater from "./pages/GuideWaterlogging.jsx";
import FloodFlash from "./pages/GuideFlashFlood.jsx";
import DamagePipeline from "./pages/GuidePipelineDamage.jsx";
import DrainClogged from "./pages/GuideCloggedDrains.jsx";
import WasteIndustrial from "./pages/GuideIndustrialWaste.jsx";
import Blogs from "./pages/Blogs";
import Addblogs from "./pages/Addblogs";
import Editblogs from "./pages/Editblogs";
import Logout from "./pages/Logout";
import { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./context/UserContext";
import Error404 from "./pages/Error404";
import AddPost from "./pages/AddPost";
import Posts from "./pages/Posts";
import Chat from "./pages/Chat";
import Maps from "./pages/Maps";
import Trending from "./pages/Trending";
import Featured from "./pages/Featured";
import About from "./pages/About";
import Donation from "./pages/Donation";
import Redeem from "./pages/Redeem";
import firebase from "firebase/compat/app"; // Import only the necessary Firebase module
import "firebase/messaging";
import { firebaseConfig } from "./firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AadhaarVerify from "./pages/AadhaarVerify";
import PaymentSuccess from "./pages/PaymentSuccess";
import Overview from "./pages/Overview";

const Privateroute = () => {
  const auth = localStorage.getItem("token");
  const { userAuth } = useContext(AuthContext);
  return <>{userAuth || auth ? <Outlet /> : <Navigate replace to={"/"} />}</>;
};
const App = () => {
  console.log("useEffect triggered");
  const { userAuth } = useContext(AuthContext);


  // Initialize Firebase and set up messaging
  const initializeFirebase = async () => {
    try {
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }

      // Register the service worker for handling push notifications
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );
        })
        .catch((error) => {
          console.error("Error registering Service Worker:", error);
        });
    } catch (error) {
      console.error("Error initializing Firebase:", error);
    }
  };

  useEffect(() => {
    initializeFirebase();

    const messaging = firebase.messaging();
    if (messaging && userAuth) {
      // Handle foreground messages
      messaging.onMessage((payload) => {
        console.log("Foreground message received:", payload);

        // Display notification using your preferred notification library
        // For example, using toast library
        toast.info("Foreground notification received");
      });
    }
  }, [userAuth]);
  useEffect(() => {
    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      const data = event.data;
      if (data && data.type === "display-notification") {
        const payload = data.payload;
        const notificationOptions = {
          body: payload.notification.body,
        };

        // Display the notification using your preferred React toast library
        toast(payload.notification.title, notificationOptions);
      }
    });
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/aadhaarVerify" element={<AadhaarVerify />} />
        <Route element={<Privateroute />}>
          <Route path="/chat" element={<Chat />} />
          <Route path="/home" element={<Home />} />
          <Route path="/maps" element={<Maps />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/trending" element={<Trending />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/posts/:id" element={<SpecificProfile />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/add" element={<Addblogs />} />
          <Route path="/blogs/edit" element={<Editblogs />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/addPost" element={<AddPost />} />
          <Route path="/guidealgae" element={<GuideAlgae />} />
          <Route path="/guidegarbdisp" element={<GarbDisp />} />
          <Route path="/guidewaterlogging" element={<LoggingWater />} />
          <Route path="/guideflashflood" element={<FloodFlash />} />
          <Route path="/guidepipelinedamage" element={<DamagePipeline />} />
          <Route path="/guideindustrialwaste" element={<WasteIndustrial />} />
          <Route path="/guidecloggeddrains" element={<DrainClogged />} />
          <Route path="/about" element={<About />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/featured" element={<Featured />} />
          <Route path="/redeem" element={<Redeem />} />
          <Route path="/paymentsuccess" element={<PaymentSuccess />} />
          <Route path="/overview" element={<Overview />} />
        </Route>
        <Route path="*" element={<Error404 />} />
      </Routes>
    </div>
  );
};

export default App;
